<!-- @veltra/icons generated sha256:b5a38e6e99629146 gen:8 source:src/svg/normal/d-arrow-left.svg -->
<script setup lang="ts">
defineOptions({ name: 'DArrowLeft' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m7.567 3.986.01.01a.65.65 0 0 1 .006.92L4.5 8l3.083 3.083a.65.65 0 0 1-.006.92l-.01.01a.63.63 0 0 1-.904-.012l-3.65-3.649a.497.497 0 0 1 0-.704l3.65-3.65a.63.63 0 0 1 .904-.012m5.017.017.01.01a.63.63 0 0 1-.01.904L9.5 8l3.083 3.083a.649.649 0 0 1-.92.918l-3.65-3.649a.497.497 0 0 1 0-.704l3.65-3.65a.653.653 0 0 1 .921.005"
    />
  </svg>
</template>
